import { useEffect, useState } from "react"
import { validateQuantity } from "../../../../utils/validations";
import useDebounce from "../../../../hooks/useDebounce";

interface PlanRevisedQtyTableCellProps {
    site:any;
    handleSavePax: (payload: object) => void;
    disabled?:any
}


const PlanRevisedPaxTableCell:React.FC<PlanRevisedQtyTableCellProps> = ({ disabled,site, handleSavePax }: any) => {
    const [pax, setPax] = useState<string>("");
    const debouncedPax = useDebounce(pax, 1000);
    const handlePaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (validateQuantity(value, 'Pax')) {
            setPax(value);
        }
    }

    useEffect(() => {
        setPax(site?.revisedpax==0 ? String(site?.pax) : String(site?.revisedpax) );
    },[site]); 

    useEffect(() => {
        if ((String(site?.revisedPax) !== debouncedPax && debouncedPax !== "" && String(site?.pax) !== debouncedPax ) ) {
            const payload = {
                sitecode: site?.sitecode,
                cafecode: site?.cafecode,
                cafename: site?.cafename,
                requestdishname: site?.requestdishname,
                requestdishcode: site?.requestdishcode,
                reviseddishname: site?.reviseddishname,
                reviseddishcode: site?.reviseddishcode,
                pax: site?.pax,
                planquantity: site?.planquantity,
                revisedpax: +debouncedPax,
                revisedquantity: site?.revisedquantity
            }
            handleSavePax(payload);
        }
    }, [debouncedPax]);

    return (
            <input type="text" value={pax} onChange={(e) => handlePaxChange(e)} placeholder="0"  disabled={disabled}/>
    )
}

export default PlanRevisedPaxTableCell